<template>
    <div>
      <div v-if="selectedCompetitors?.length">
        {{ selectedCompetitors?.length || 0 }} competitors selected
      </div>
      <div v-else style="color: var(--v-darkGrayColor-base); font-weight: normal;">
        {{ selectedCompetitors?.length || 0 }} competitors selected
      </div>
    </div>
</template>

<script>
import {
  STEPS,
} from "@/components/FullPageSourceEditorV2/components/AiWriter/constants.js";

export default {
    name: 'ConfigPreviewCompetitors',
    props: [
        'selectedCompetitors',
    ],
    computed: {
        STEPS() {
          return STEPS
        },
    }
}
</script>

<style lang="scss" scoped>

</style>